import {v1_AffiliateOrderCategoriesPriority_select_column} from '../../generated/types';

const AffiliateOrderCategoryPriority = {
    ...v1_AffiliateOrderCategoriesPriority_select_column,
    res: 'v1_AffiliateOrderCategoriesPriority',
    comp: {},
    rel: {},
};

export default AffiliateOrderCategoryPriority;
